import React from 'react';
import {theme} from '../../../styles/darkTheme';
import {Text} from './styles';
import Modal from 'react-bootstrap/Modal';
import {useDispatch, useSelector} from 'react-redux';
import {RootState} from '../../../redux/reducers';
import {useTranslation} from '../../../context/language';
import {ButtonsContainer, ModalButton} from './styles';
import {setAlert} from '../../../redux/actions/global';

const AppAlert: React.FC = () => {
  const {alert} = useSelector((state: RootState) => ({
    ...state.global,
  }));
  const {text} = useTranslation();
  const dispatch = useDispatch();

  const handleClose = () => {
    dispatch(setAlert({message: '', title: ''}));
    if (alert?.callback) alert.callback();
  };

  return (
    <Modal show={alert?.message !== ''} onHide={handleClose}>
      <Modal.Header closeButton>
        <Text theme={theme} type="bold">
          {alert?.title}
        </Text>
      </Modal.Header>
      <Modal.Body>
        {alert?.message && (
          <Text theme={theme} type="normal">
            {alert?.message}
          </Text>
        )}
        <ButtonsContainer>
          <ModalButton theme={theme} onClick={handleClose}>
            {text.close}
          </ModalButton>
        </ButtonsContainer>
      </Modal.Body>
    </Modal>
  );
};

export default AppAlert;
